export default __webpack_public_path__ + "static/media/ic_soon.59494c09.svg";